import { Redirect, useLocalSearchParams } from "expo-router";
import React from "react";

import PageLayout from "$src/core/components/templates/PageLayout";
import useApi from "$src/core/hooks/use-api";
import RegisterPage from "$src/core/pages/RegisterPage/RegisterPage";

type Params = {
  redirect?: string;
};

const Route: React.FC = () => {
  const { redirect } = useLocalSearchParams<Params>();
  const { api } = useApi();

  if (!api.register) {
    return (
      <Redirect href={redirect ? `/login?redirect=${redirect}` : "/login"} />
    );
  }

  return (
    <PageLayout>
      <RegisterPage redirect={redirect} />
    </PageLayout>
  );
};

export default Route;
